import React from 'react';
import styled from 'styled-components';
import { FlexCenter } from '../Flex';
import Loader from './Loader';

const LoaderWrapper = styled(FlexCenter)`
  flex: 1;
`;

const LoaderArea = ({ size = 'medium' }) => (
  <LoaderWrapper>
    <Loader size={size} />
  </LoaderWrapper>
);

export default LoaderArea;
